import { styled } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectSystemControl } from '../../../containers/common/store/slices/systemControl'

const fontSizeLv = {
  lv0: 0,
  lv1: 1,
  lv2: 2,
  lv3: 3,
} as const

const fontSizeNames = {
  [fontSizeLv.lv0]: 'sizeS',
  [fontSizeLv.lv1]: 'sizeM',
  [fontSizeLv.lv2]: 'sizeL1',
  [fontSizeLv.lv3]: 'sizeL2',
} as const
type fontSizeNameKey = keyof typeof fontSizeNames

const Root = styled('span', { shouldForwardProp: (prop) => prop !== 'lv' })<{ lv: fontSizeNameKey, textLength?: number }>(
    ({ theme, lv, textLength }) => (
        {
          '--text-length': textLength ?? 1,
          '--max-font-size': theme.typography.font[fontSizeNames[lv]],
          '--font-size': 'calc((100vw - 140px) / var(--text-length))',
          fontSize: 'clamp(1px, var(--font-size), var(--max-font-size))', // ログインボタンと重ならない程度に、画面幅に応じた可変文字サイズ
          letterSpacing: 0,
        }
    )
)

export const SystemLogo = () => {
  const {serviceTitle, iconImageName} = useSelector(selectSystemControl)
  let serviceTitleLength = serviceTitle?.length
  const hasIconImage = (iconImageName && iconImageName !== "") ? true: false

  if(hasIconImage){
    // ロゴ画像がある場合は、幅2.5文字分として計算
    serviceTitleLength += 2.5;
  }

  // let lv: fontSizeNameKey = fontSizeLv.lv0
  // if (serviceTitleLength < 14) {
  //   lv = fontSizeLv.lv3
  // } else if (serviceTitleLength < 18) {
  //   lv = fontSizeLv.lv2
  // } else if (serviceTitleLength < 23) {
  //   lv = fontSizeLv.lv1
  // }

  // return <Root lv={lv}>{serviceTitle}</Root>
  return <Root lv={fontSizeLv.lv3} textLength={serviceTitleLength}>{serviceTitle}</Root>
}
